import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import ProductCardOrganism from '~/components/_next/organisms/ProductCardOrganism.vue';
import AzCarousel from '~/components/_next/molecules/AzCarousel.vue';
import { useCart } from '~/composables/useCart';
import { useRelatedProductsStore } from '~/composables/_next/stores/useRelatedProductsStore';
import useRightPath from '~/composables/useRightPath';
export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedProductsOrganism',
  props: {
    relatedProductsSku: null,
    description: null,
    title: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useRelatedProductsSt = useRelatedProductsStore(),
      fetchRelatedProducts = _useRelatedProductsSt.fetchRelatedProducts,
      availableRelatedProducts = _useRelatedProductsSt.availableRelatedProducts;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var relatedProductsSku = computed(function () {
      return props.relatedProductsSku;
    });
    useLazyAsyncData('related-products', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchRelatedProducts({
              skus: relatedProductsSku.value
            });
          case 2:
            return _context.abrupt("return", true);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var sortedRelatedProducts = computed(function () {
      return availableRelatedProducts.value.filter(function (product) {
        return getProductPath(product);
      }).sort(function (a, b) {
        var _relatedProductsSku$v, _relatedProductsSku$v2;
        return ((_relatedProductsSku$v = relatedProductsSku.value) === null || _relatedProductsSku$v === void 0 ? void 0 : _relatedProductsSku$v.indexOf(a.sku)) - ((_relatedProductsSku$v2 = relatedProductsSku.value) === null || _relatedProductsSku$v2 === void 0 ? void 0 : _relatedProductsSku$v2.indexOf(b.sku));
      });
    });
    var relatedProductsTitle = computed(function () {
      return props.title ? props.title : i18n.tc('related.products', sortedRelatedProducts.value.length);
    });
    var _useCart = useCart(),
      addItemToCart = _useCart.addItem;
    var addToCart = function addToCart(_ref2) {
      var product = _ref2.product,
        quantity = _ref2.quantity;
      var id = product.id,
        sku = product.sku;
      addItemToCart({
        product: {
          id: id,
          sku: sku
        },
        quantity: quantity
      });
    };
    return {
      __sfc: true,
      fetchRelatedProducts: fetchRelatedProducts,
      availableRelatedProducts: availableRelatedProducts,
      i18n: i18n,
      getProductPath: getProductPath,
      relatedProductsSku: relatedProductsSku,
      props: props,
      sortedRelatedProducts: sortedRelatedProducts,
      relatedProductsTitle: relatedProductsTitle,
      addItemToCart: addItemToCart,
      addToCart: addToCart,
      ProductCardOrganism: ProductCardOrganism,
      AzCarousel: AzCarousel
    };
  }
});